(() => {
    const initSiteNavDropdowns = () => {
        const $mobileSubMenuWraps = document.querySelectorAll('.site-menu-modal .menu-item-has-children');

        if ($mobileSubMenuWraps.length) {
            $mobileSubMenuWraps.forEach($subMenuWrap => {
                const $subMenuWrapBtn = $subMenuWrap.querySelector('a');
                const $subMenu = $subMenuWrap.querySelector('.sub-menu-dropdown');

                const showSubMenu = () => {
                    $subMenu.style.height = `${$subMenu.scrollHeight}px`;
                    $subMenuWrap.classList.add('menu-item--active');

                    setTimeout(() => {
                        $subMenu.style.height = '';
                    }, 250);
                };

                const hideSubMenu = () => {
                    $subMenu.style.height = `${$subMenu.scrollHeight}px`;
                    $subMenuWrap.classList.remove('menu-item--active');

                    setTimeout(() => {
                        $subMenu.style.height = '';
                    }, 10);
                };

                $subMenuWrapBtn.addEventListener('click', e => {
                    e.preventDefault();

                    $subMenuWrapBtn.removeEventListener('mouseleave', () => {
                        hideSubMenu();
                    });

                    if ($subMenuWrap.classList.contains('menu-item--active')) {
                        hideSubMenu();
                    } else {
                        showSubMenu();
                    }
                });
            });
        }
    };

    initSiteNavDropdowns();
})();
